import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/view-design';
import 'view-design/dist/styles/iview.css';
//import probes from '@hll/sign-web'
//const probes = require('./index.js');
//console.log(probes)
//probes.init({ txt: "水印内容", bright:888, fft_encode: 888, rgb_encode: 888, dom_encode: 888 })
//

window.probes.init({ debug: true });
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
